import {
    isFunction,
    isObject
} from "./main";
import {
    deepClone,
    deepMixin
} from "./obj";

// http://ejohn.org/blog/objectgetprototypeof/
// определение прототипа объекта
if ( typeof Object.getPrototypeOf !== "function" ) {
    if ( typeof "test".__proto__ === "object" ) {
        Object.getPrototypeOf = function(object) {
            return object.__proto__;
        };
    } else {
        Object.getPrototypeOf = function(object) {
            // May break if the constructor has been tampered with
            return object.constructor.prototype;
        };
    }
}

/**
 * create new class from base class with additional properties
 * @member f
 * @param {class|Function} Child
 * @param {class|Object} Parent
 */
export function extend(Child, Parent) {
    let F;
    if ( Parent.className ) {
        F = new Function("", "function " + Parent.className + "(){}"); // jshint ignore:line
    } else {
        F = function() {};
    }
    F.prototype = Parent.prototype;
    Child.prototype = new F();
    Child.prototype.constructor = Child;

    if ( !Parent.Children ) {
        Parent.Children = [];
    }

    if ( Parent.Children.indexOf(Child) == -1 ) {
        Parent.Children.push(Child);
    }
}

export function CreateConstructor(className, func) {
    let defClassName = "MyClass";

    if ( arguments.length === 0 ) {
        className = defClassName;
    }

    if ( isFunction(className) ) {
        if ( isFunction(func) ) {
            let originalConstructor = className;
            let otherConstructor = func;

            func = function() {
                // для Singleton
                let that = originalConstructor.apply(this, arguments);
                otherConstructor.apply(that, arguments);
                return that;
            };
        } else {
            func = className;
        }

        if ( /^function \w+/gi.test(className.toString()) ) {
            className = className.toString().match(/function (\w+)/)[1] || defClassName;
        } else {
            className = defClassName;
        }
    }

    if ( !func ) {
        func = defaultConstructor();
    }
    // для того, чтобы в консоли объекты класса
    // подписивались именем className, воспользуемся new Function
    let MyClass = new Function("func", "return function " + className + "(){\n\r return func.apply(this, arguments)};")(func); // jshint ignore: line
    MyClass.className = className;
    return MyClass;
}

let allConstructos = [];
allConstructos.hasInstance = function(obj) {
    for (let i = 0, n = allConstructos.length; i < n; i++) {
        if ( obj instanceof allConstructos[i] ) {
            return true;
        }
    }
    return false;
};

/**
     * create new class from {@link BaseClass}
     * @param className
     * @param proto
     * @param Parent
     * @return {class}
     */
export function CreateClass(className, proto, Parent) {
    /**
         * @class BaseClass
         */
    let MyClass;
    if ( isFunction(className) ) {
        MyClass = CreateConstructor(className, defaultConstructor());
        className = MyClass.className;
    } else {
        MyClass = CreateConstructor(className);
    }

    // наследование и
    // ссылка на конструктор родителя
    if ( isFunction(Parent) ) {
        extend(MyClass, Parent);
        MyClass.__super__ = Parent.prototype;
    } else {
        MyClass.__super__ = null;
    }
    MyClass.Parent = Parent;

    // запись имени класса
    MyClass.className = className || "MyClass";
    // объект, из которого будет заполнятся каждый новый объект
    MyClass.defaults = {};

    // если в прототипе будут лежать св-ва-не методы
    // то изменение этих св-в приведет к глобальному изменению св-ва у всех объектов,
    // привязанных к прототипу
    // поэтому разделяем объект proto на методы и "значения по умолчанию"
    for (let key in proto) {
        if ( isFunction(proto[key]) ) {
            MyClass.prototype[key] = proto[key];
        } else {
            MyClass.defaults[key] = proto[key];
        }
    }

    MyClass.defaults = mathDefaults(MyClass);

    MyClass.extend = function(childClassName, proto) {
        let SelfClass = this;

        if ( arguments.length === 0 ) {
            childClassName = "Child" + className;
        }

        if ( arguments.length == 1 && isObject(childClassName) ) {
            proto = childClassName;
            childClassName = "Child" + className;
        }

        if ( !isObject(proto) ) {
            proto = {};
        }

        return CreateClass(childClassName, proto, SelfClass);
    };

    allConstructos.push(MyClass);
    return MyClass;
}

CreateClass.hasInstance = function(obj) {
    return allConstructos.hasInstance(obj);
};

// проходим по цепочке конструкторов и собираем
// значения по умолчанию в один объект
export function mathDefaults(Child) {
    if ( !Child ) {
        Child = this.constructor;
    }

    let defaultsArr = [Child.defaults];


    let defaults = {};

    while ( Child.__super__ && isFunction(Child.__super__.constructor) ) {
        Child = Child.__super__.constructor;
        defaultsArr.push(Child.defaults || {});
    }

    defaults = deepMixin.apply(null, defaultsArr.reverse());

    return deepClone(defaults);
}

export function defaultConstructor() {
    let DefConstructor = function() {
        // значения по умолчанию
        for (let key in this.constructor.defaults || {}) {
            if ( !isFunction(this[key]) ) {
                this[key] = deepClone(this.constructor.defaults[key]);
            }
        }

        if ( this.__beforeInit ) {
            this.__beforeInit.apply(this, arguments);
        }

        if ( this.init ) {
            this.init.apply(this, arguments);
        }
    };

    return DefConstructor;
}

export function CreateClassBackward(className, proto, Parent) {

    let MyClass = new Function("input", `
        return class ${className} extends input.Parent {}
    `)({ Parent });

    MyClass.__super__ = Parent.prototype;
    MyClass.Parent = Parent;

    // запись имени класса
    MyClass.className = className;
    // объект, из которого будет заполнятся каждый новый объект
    MyClass.defaults = {};

    // если в прототипе будут лежать св-ва-не методы
    // то изменение этих св-в приведет к глобальному изменению св-ва у всех объектов,
    // привязанных к прототипу
    // поэтому разделяем объект proto на методы и "значения по умолчанию"
    for (let key in proto) {
        if ( isFunction(proto[key]) ) {
            MyClass.prototype[key] = proto[key];
        } else {
            MyClass.defaults[key] = proto[key];
        }
    }

    MyClass.defaults = mathDefaults(MyClass);

    MyClass.extend = function(childClassName, proto) {
        let SelfClass = this;

        if ( arguments.length === 0 ) {
            childClassName = "Child" + className;
        }

        if ( arguments.length == 1 && isObject(childClassName) ) {
            proto = childClassName;
            childClassName = "Child" + className;
        }

        if ( !isObject(proto) ) {
            proto = {};
        }

        return CreateClass(childClassName, proto, SelfClass);
    };

    allConstructos.push(MyClass);
    return MyClass;
}
